// extracted by mini-css-extract-plugin
export default {"card_element":"Global_card_element__49KeV"};